module.exports = __webpack_public_path__ + "static/media/galerija_2013 (1).95761f2c.JPG";